import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "workflows",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "workflows-chunk" */ "./components"),
      import(
        /* webpackChunkName: "workflows-reducer" */ "Workflows/modules/WorkflowsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const reducerName = importedModule1.NAME;

      injectReducer(store, {
        key: reducerName,
        reducer,
      });
      return component;
    })
  ),
});
